"use client";
import React from "react";
 import { useProductDetails } from "../../context/ProductDetailsContext"; // adjust path as needed

function TabbedContent() {
  const { product, loading } = useProductDetails();

  if (loading) return <div>Loading...</div>;
  if (!product) return <div>No product data available.</div>;

  const specifications = [
    {
      category: "SAREE",
      items: [
        { label: "Craft :", value: "Embroidered" },
        { label: "Pattern :", value: "All over" },
        { label: "Purity :", value: "Pure" },
        { label: "Saree Color :", value: "Crimson Red" },
        { label: "Saree Fabric :", value: "Crepe" },
        { label: "Saree length :", value: "5.5 Mtrs" },
        {
          label: "Saree Work :",
          value: "Printed, Sequins, Stone\nand Pearl Work",
        },
      ],
    },
    {
      category: "BORDER/PALLU",
      items: [
        { label: "Saree Border Color :", value: "Green and Cream" },
        { label: "Saree Border Fabric :", value: "Crepe" },
        {
          label: "Saree Border Work :",
          value: "Printed, Sequins and\nStone Work",
        },
      ],
    },
    {
      category: "BLOUSE",
      items: [
        { label: "Blouse Fabric :", value: "Crepe" },
        { label: "Blouse Length :", value: "38 cm" },
        { label: "Blouse pattern :", value: "Readymade" },
        {
          label: "Saree Blouse work :",
          value: "Printed, Sequins and\nStone Work",
        },
        { label: "Saree Blouse Color :", value: "Crimson Red" },
      ],
    },
  ];
 
  return (
    <section className="font-medium w-full border border-solid border-stone-300 p-6 md:p-9">
      {/* ---- DESCRIPTION ---- */}
      <div className="mb-10">
        <h3 className="text-lg md:text-xl text-yellow-500 font-semibold text-neutral-700 mb-6">
          DESCRIPTION
        </h3>
        <div className="text-sm md:text-base text-zinc-600 leading-relaxed space-y-4">
          {product.description
            ? product.description.split("\n").map((line, idx) => (
                <p key={idx}>{line.trim()}</p>
              ))
            : (
              <p>No description available for this product.</p>
            )}
        </div>

      </div>
 
    </section>
  );
}

export default TabbedContent;